import UserStore from '../flux/UserStore';

// @todo 2018-03-07 Refactor this into a dedicated JSON file (alike Laravel)
const languages = {
  en_UK: {
    'theme_new': 'New',
    'theme_viewed': 'Started',
    'theme_completed': 'Completed',
    'theme_updated': 'Updated',

    'product_focus_new': 'New',
    'product_focus_started': 'Started',
    'product_focus_completed': 'Completed',

    'EUR': 'Europe',
    'MDE': 'Middle East',
    'AMR': 'USA',
    'KOR': 'Korea',
    'FST': 'Hong Kong + Macao + Taiwan',
    'CHI': 'China Mainland',
    'JAP': 'Japan',
    'BRZ': 'Brazil',
    'SEA': 'Sea',

    'Hot now': 'Hot now',
    'To complete': 'To complete',
    'Never seen': 'Never seen',
    'seasonal':	'seasonal',
    'timeless': 'timeless',
    'glossary':	'glossary',
    'product-focus':	'product focus',
    'merchandising-manual':	'manuals',
    'never seen': 'never seen',
    'manuals': 'manuals',
    'terms': 'terms',
    'more': 'more',
    'Show all seasonal': 'Show all Seasonal',
    'Show all timeless': 'Show all Timeless',
    'Show all glossary': 'Show all Glossary',
    'Show all product-focus': 'Show all Product-focus',
    'Show all merchandising-manual': 'Show all Manuals'
  },
  zh_CN: {
    'EUR': 'Europe',
    'MDE': 'Middle East',
    'AMR': 'USA',
    'KOR': 'Korea',
    'FST': 'Hong Kong + Macao + Taiwan',
    'CHI': 'China Mainland',
    'JAP': 'Japan',
    'BRZ': 'Brazil',
    'SEA': 'Sea',

    'Home': '主頁',
    'Seasonal': '季節性',
    'Seasonal Archive': '季節性存檔',
    'Timeless': '經典',
    'Introduction': '介紹',
    'Themes': '主題',
    'Manuals': '手冊',
    'Merchandising Manuals': '產品採購手冊',
    ':length themes available': ':length 個主題',
    'Go to top': '回到頂部',
    'All': '全部',
    'Alphabetical': '按英文字母順序',
    'Newest': '最新',
    'Glossary': '詞匯表',
    'Sort by': '排序方式',
    'Filter by': '過濾',
    'Search': '搜索',
    'Archive': '存檔',
    'Discover Also': '進一步了解',
    'Start now': '現在開始',
    'Themes (:length)': '主題（:length）',
    'To Complete': '去完成',
    'Seasonal / Non seasonal': '季節性/非季節性',
    'Updated Content': '更新內容',
    'Your Valentino Username (5 digits)': '你Valentino的用户名（5位数字）',
    'Username or password are incorrect': '用户名或密码不正确',
    'Login failed': '登錄失敗',
    'Loading...': '載入中...',
    'Congratulations!': '恭喜！',
    'Username': '用戶名',
    'Password': '密碼',
    'Related content': '相關內容',
    'User area': '用戶區',
    'Language': '語言',
    'English': '英語',
    'Japanese': '日本語',
    'Korean': '韓國語',
    'Portuguese': '葡萄牙語',
    'Russian': '俄語',
    'Chinese': '中文',
    'Feedback': '回饋',
    'Logout': '登出',
    'Video Manual': '录像手册',
    'Store': '店舖',
    'Stores': '店舖',
    'Theme completed': '主题完成',
    'Completed: :percentage%': '已完成： :percentage％',
    'Search results': '搜索結果',
    'Your search results for:': '你的搜索結果：',
    'No search results for ":query"': '沒有":query"的搜索結果',
    'Try to change your search query': '尝试更改你的搜素查询',
    'Try to change your filters': '尝试更改你的筛选',
    'Category': '類別',
    'theme_new': '新主題',
    'theme_viewed': '已開始',
    'theme_completed': '已完成',
    'theme_updated': '已更新',
    'Got the big picture? Now let’s go deeper': '完成了概覽？現在讓我們更深入了解',
    'That’s great, keep up and move to the next one!': '太棒了，繼續前進到下一頁！',
    'That’s great!': '很棒！',
    'Go to archive': '前往存檔',
    'View all': '查看全部',
    'There are some new content for you!': '有一些新的內容給你！',
    'Check out your notification': '看看你的通知',
    'Go to notification': '前往通知',
    'Reports': '報告',
    'Worldwide :percentage': '全球 :percentage',
    // @todo 2019-11-05
    //   "Worldwide" was copied and modified from above entry, should be
    //   validated
    'Worldwide': '全球',
    'Name': '名稱',
    'Active users': '活躍用戶',
    'Content done': '已完成內容',
    'Completed theme': '已完成主題',
    'Active': '活躍',
    'Inactive': '不活躍',
    'Report a problem': '報告問題',
    'Report :count person': '报告（:count）人',
    'Report :count people': '报告（:count）人',
    'Expand': '展開',
    'Close': '關閉',
    'No results for the selected store.': '所選店舖沒有結果。',
    'No results for the selected country.': '所選國家沒有結果。',
    'No results for the selected region.': '所選區域沒有結果。',
    'No results for the selected collection.': '所選系列沒有結果。',
    'No results for the selected user.': '所選用戶沒有結果。',
    'Europe': '歐洲',
    'Middle East': '中東',
    'Asia Pacific': '亞太地區',
    'Korea': '韓國',
    'USA': '美國',
    'Japan': '日本',
    'Brazil': '巴西',
    'Sea': '東南亞',
    'When you are done studying, mark this theme as completed by tapping the button below.': '完成學習後，點擊下面的按鈕將此主題標記為已完成。',
    'Mark as completed': '標記為已完成',
    'Check all the collection themes': '檢查所有系列主題',
    'Logging in...': '登入中',
    'Login': '登入',
    'Notifications': '通知',
    'News feed': '資訊更新',
    'No news available': '無新資訊',
    ':length media': ':length 長度',
    'No Glossary terms found': '沒有搜尋詞匯',
    'Find out all the collection themes': '找出所有系列主題',
    'Find out all the category themes': '找出所有類別主題',
    'There are news for you!': '你有新信息！',
    'Check out the news feed in your page': '查看您網頁中的資訊更新',
    'Go to my profile page': '轉到我的個人資料頁面',
    'Scroll Down': '向下滾動鼠標',
    'Change password': '更改密码',
    'You can change your password by submitting the form below. The new password must be different than your last five passwords.': '您可以通过提交以下表格来更改密码。新密码必须不同于前5次。',
    'Your password has been changed successfully.': '你已经成功更改密码',
    'Current password': '当前密码',
    'New password': '新密码',
    'Repeat new password': '重复新密码',
    'product_focus_new': '新主題',
    'product_focus_started': '已開始',
    'product_focus_completed': '已完成',
    'Product focus': '产品焦点',
    'New Product Focus': '新产品焦点',
    'Later': '后面',
    'View Product Focus': '查看产品焦点',
    'Do you want to enable secure authentication for a faster and easier access?': '你是否要启用安全验证以更快更便捷地访问？',
    'Secure authentication failed': '安全身份验证失败',

    'Hot now': '热门商品',
    'To complete': '待完成',
    'Never seen': '未曾被检视过',
    'seasonal':	'季节性',
    'timeless': '隽永',
    'glossary':	'词汇表',
    'product-focus':	'商品-专注',
    'merchandising-manual':	'促销-手冊',
    'never seen': '未曾被检视过',
    'manuals': '手冊',
    'terms': '条款',
    'more': '更多',
    'Show all seasonal': '显示所有季節性',
    'Show all timeless': '显示所有隽永',
    'Show all glossary': '显示所有词汇表',
    'Show all product-focus': '显示所有商品-专注',
    'Show all merchandising-manual': '显示所有促销-手冊',

    'You are currently logged-in as :email, is that you?': '您当前以 :email 的身份登录，是您本人吗？',
    'Yes': 'はい是',
    'No, logout': '不，登出いいえ、ログアウト',
  },
  ja_JP: {
    'Home':	'ホーム',
    'Seasonal': 'シーズナル',
    'Seasonal Archive': 'シーズナルアーカイブ',
    'Timeless': 'タイムレス',
    'Introduction': 'イントロダクション',
    'Themes': 'テーマ',
    'Manuals': 'マニュアル',
    'Merchandising Manuals': 'マーチャンダイジング マニュアル',
    ':length themes available': 'テーマの数',
    'Go to top': 'トップへ',
    'All': 'すべて',
    'Alphabetical':	'アルファベット順',
    'Newest': '最新',
    'Glossary': '用語',
    'Sort by': '並べ替え',
    'Filter by': 'フィルター',
    'Search': '検索',
    'Archive': 'アーカイブ',
    'Discover Also': 'こちらも見る',
    'Start now': 'スタートする',
    'Themes (:length)': '(:length) テーマ',
    'To Complete': '完了',
    'Seasonal / Non seasonal': 'シーズナル/シーゾナルでないもの',
    'Updated Content': '更新されたコンテンツ',
    'Your Valentino Username (5 digits)': 'ユーザー名　（5桁）',
    'Username or password are incorrect': 'ユーザー名またはパスワードが正しくありません',
    'Login failed': 'ログインエラー',
    'Loading...': 'ローディング',
    'Congratulations!': 'おめでとうございます！',
    'Username': 'ユーザーネーム',
    'Password': 'パスワード',
    'Related content': '関連するコンテンツ',
    'User area': 'ユーザーエリア',
    'Language': '言語',
    'English': '英語',
    'Japanese': '日本語',
    'Korean': '韓国語',
    'Portuguese': 'ポルトガル語',
    'Russian': 'ロシア語',
    'Chinese': '中国語',
    'Feedback': 'フィードバック',
    'Logout': 'ログアウト',
    'Video Manual': '動画マニュアル',
    'Store': 'ストア',
    'Stores': 'ストア',
    'Theme completed': 'テーマが完了',
    'Completed: :percentage%': '完了： :percentage％',
    'Search results': '検索結果',
    'Your search results for:': '検索結果：',
    'No search results for ":query"': '":query" は見つかりませんでした',
    'Try to change your search query': '検索クリエを変更してみてください',
    'Try to change your filters': 'フィルターの交換をしてみてください',
    'Category': 'カテゴリー',
    'theme_new': '新規',
    'theme_viewed': 'スタート',
    'theme_completed': '完了',
    'theme_updated': '更新',
    'Got the big picture? Now let’s go deeper': '全体像が把握できましたか？ ではもう少し詳しく見てみましょう',
    'That’s great, keep up and move to the next one!': 'すばらしい！その調子で次に進みましょう！',
    'That’s great!': 'すばらしい！',
    'Go to archive': 'アーカイブを見る',
    'View all': 'すべて見る',
    'There are some new content for you!': '新しいコンテンツがあります！',
    'Check out your notification': 'お知らせを確認する',
    'Go to notification': 'お知らせを確認する',
    'Reports': 'レポート',
    'Worldwide :percentage': 'ワールドワイド :percentage',
    // @todo 2019-11-05
    //   "Worldwide" was copied and modified from above entry, should be
    //   validated
    'Worldwide': 'ワールドワイド',
    'Name': '名前',
    'Active users': 'アクティブユーザー',
    'Content done': '完了したコンテンツ',
    'Completed theme': '完了したテーマ',
    'Active': 'アクティブ',
    'Inactive': 'インアクティブ',
    'Report a problem': '問題を報告する',
    'Report :count person': 'レポート（:count ） 人',
    'Report :count people': 'レポート（:count ） 人',
    'Expand': '拡大する',
    'Close': '閉じる',
    'No results for the selected store.': '選択されたストアは見つかりませんでした',
    'No results for the selected country.': '選択された国は見つかりませんでした',
    'No results for the selected region.': '選択された地域は見つかりませんでした',
    'No results for the selected collection.': '選択されたコレクションは見つかりませんでした',
    'No results for the selected user.': '選択されたユーザーは見つかりませんでした',
    'Europe': 'ヨーロッパ',
    'Middle East': '中東',
    'Asia Pacific': 'アジア太平洋',
    'Korea': '韓国',
    'USA': 'アメリカ合衆国',
    'Japan': '日本',
    'Brazil': 'ブラジル',
    'Sea': '海',
    'When you are done studying, mark this theme as completed by tapping the button below.': '学習を終えたら、下のボタンをクリックしてこのテーマを完了してください',
    'Mark as completed': '完了する',
    'Check all the collection themes': 'すべてのコレクションテーマを確認する',
    'Logging in...': 'ログイン中',
    'Login': 'ログイン',
    'Notifications': 'お知らせ',
    'News feed': 'ニュース',
    'No news available': 'ニュースはありません',
    ':length media': 'メディア:length',
    'No Glossary terms found': '用語はありません',
    'Find out all the collection themes': 'すべてのコレクションテーマを探す',
    'Find out all the category themes': 'すべてのカテゴリーのテーマを見る',
    'There are news for you!': 'あなたにお知らせです！',
    'Check out the news feed in your page': 'マイページでニュースフィードを見る',
    'Go to my profile page': 'プロフィールページへ',
    'Scroll Down': '下へスクロールする',
    'Change password': 'パスワードの変更',
    'You can change your password by submitting the form below. The new password must be different than your last five passwords.': '次のフォームを送信するとパスワードを変更することができます。新しいパスワードに過去5回のパスワードを再利用してはいけません。',
    'Your password has been changed successfully.': 'パスワードの変更に成功しました。',
    'Current password': '現在のパスワード',
    'New password': '新しいパスワード',
    'Repeat new password': '新しいパスワードをもう一度入力',
    'product_focus_new': '新規',
    'product_focus_started': 'スタート',
    'product_focus_completed': '完了',
    'Product focus': '製品の概要',
    'New Product Focus': '新製品の概要',
    'Later': '後にする',
    'View Product Focus': '製品の概要を表示',
    'Do you want to enable secure authentication for a faster and easier access?': 'アクセスをより速く、より簡単にするために安全な認証を有効にしたいですか？',
    'Secure authentication failed': 'セキュア認証に失敗しました',

    'Hot now': 'ホットナウ',
    'To complete': '入力',
    'Never seen': '未公開',
    'seasonal':	'シーズナル',
    'timeless': 'タイムレス',
    'glossary':	'グロッサリー',
    'product-focus':	'製品フォーカス',
    'merchandising-manual':	'マニュアル',
    'never seen': '未公開',
    'manuals': 'マニュアル',
    'terms': '条件',
    'more': '詳細',
    'Show all seasonal': '全てのシーズナルを表示',
    'Show all timeless': '全てのタイムレスを表示',
    'Show all glossary': '全てのグロッサリーを表示',
    'Show all product-focus': '全ての製品フォーカスを表示',
    'Show all merchandising-manual': 'すべてのマニュアルを表示',

    'You are currently logged-in as :email, is that you?': '現在、:email としてログインしています。本人ですか？',
    'Yes': 'はい',
    'No, logout': 'いいえ、ログアウト',
  },
  ko_KP: {
    'EUR': 'Europe',
    'MDE': 'Middle East',
    'AMR': 'USA',
    'KOR': 'Korea',
    'FST': 'Hong Kong + Macao + Taiwan',
    'CHI': 'China Mainland',
    'JAP': 'Japan',
    'BRZ': 'Brazil',
    'SEA': 'Sea',

    'Home': '홈',
    'Seasonal': '시즌상품',
    'Seasonal Archive': '시즌 아카이브',
    'Timeless': '타임리스',
    'Introduction': '소개',
    'Themes': '테마',
    'Manuals': '매뉴얼',
    'Merchandising Manuals': '머천다이징 매뉴얼',
    ':length themes available': ':length 개의 이용 가능한 테마',
    'Go to top': '맨 위로 가기',
    'All': '모두보기',
    'Alphabetical': '알파벳순',
    'Newest': '최신순',
    'Glossary': '용어',
    'Sort by': '분류',
    'Filter by': '필터',
    'Search': '검색',
    'Archive': '아카이브',
    'Discover Also': '추가 탐색하기',
    'Start now': '지금 시작하기',
    'Themes (:length)': '테마 (:length)',
    'To Complete': '완료하기',
    'Seasonal / Non seasonal': '시즌상품/비시즌상품',
    'Updated Content': '업데이트된 내용',
    'Your Valentino Username (5 digits)': '5자리 사용자이름',
    'Username or password are incorrect': '사용자 이름/ 비밀번호 오류',
    'Login failed': '로그인 실패',
    'Loading...': '로딩중…',
    'Congratulations!': '축하합니다!',
    'Username': '사용자이름',
    'Password': '패스워드',
    'Related content': '관련된 내용들',
    'User area': '사용자 영역',
    'Language': '언어',
    'English': '영어',
    'Japanese': '일본어',
    'Korean': '한국어',
    'Portuguese': '포르투갈어',
    'Russian': '러시아어',
    'Chinese': '중국어',
    'Feedback': '피드백',
    'Logout': '로그아웃',
    'Video Manual': '비디오 매뉴얼',
    'Store': '매장',
    'Stores': '매장들',
    'Theme completed': '테마 완료',
    'Completed: :percentage%': '완료됨: :percentage%',
    'Search results': '검색 결과',
    'Your search results for:': '검색한 결과:',
    'No search results for ":query"': '":query" 로 검색한 결과가 없습니다.',
    'Try to change your search query': '검색 질문을 바꿔 보세요.',
    'Try to change your filters': '조건을 바꿔 보세요. ',
    'Category': '카테고리',
    'theme_new': '신규',
    'theme_viewed': '시작됨',
    'theme_completed': '완료됨',
    'theme_updated': '업데이트됨',
    'Got the big picture? Now let’s go deeper': '전체 내용 이해하셨나요? 이제 더 자세히 알아 보겠습니다.',
    'That’s great, keep up and move to the next one!': '훌륭해요, 이제 다음 단계로 이동해 보겠습니다.',
    'That’s great!': '훌륭해요!',
    'Go to archive': '아카이브로 가기',
    'View all': '모두보기',
    'There are some new content for you!': '새로운 컨텐츠가 있습니다!',
    'Check out your notification': '알림사항을 체크해 보세요.',
    'Go to notification': '알림 확인하러 가기',
    'Reports': '레포트',
    'Worldwide :percentage': '월드와이드 :percentage',
    // @todo 2019-11-05
    //   "Worldwide" was copied and modified from above entry, should be
    //   validated
    'Worldwide': '월드와이드',
    'Name': '이름',
    'Active users': '사용중인 유저',
    'Content done': '완료된 컨텐츠',
    'Completed theme': '완성된 테마',
    'Active': '사용중',
    'Inactive': '비사용중',
    'Report a problem': '문제사항 보고하기',
    'Report :count person': '개인 보고하기 : :count',
    'Report :count people': '여러 명 보고하기 : :count',
    'Expand': '확장하기',
    'Close': '닫기',
    'No results for the selected store.': '선택된 매장에 대한 결과가 없음.',
    'No results for the selected country.': '선택된 나라에 대한 결과가 없음.',
    'No results for the selected region.': '선택된 지역에 대한 결과가 없음.',
    'No results for the selected collection.': '선택된 컬렉션에 대한 결과가 없음.',
    'No results for the selected user.': '선택된 사용자에 대한 결과가 없음',
    'When you are done studying, mark this theme as completed by tapping the button below.': '학습이 모두 완료되었다면 아래의 버튼을 탭하여 이 테마를 완성했다고 체크하세요.',
    'Mark as completed': '완성된 항목으로 체크하기 ',
    'Check all the collection themes': '모든 컬렉션 테마 확인하기',
    'Logging in...': '로그인 중입니다….',
    'Login': '로그인',
    'Notifications': '알림사항',
    'News feed': '뉴스피드',
    'No news available': '새로운 뉴스가 없습니다.',
    ':length media': ':length 지속시간',
    'No Glossary terms found': '연관된 용어 검색결과가 없음.',
    'Find out all the collection themes': '모든 컬렉션 테마 찾아보기',
    'Find out all the category themes': '모든 카테고리 테마 찾아보기',
    'There are news for you!': '새로운 소식이 있습니다!',
    'Check out the news feed in your page': '현재 페이지의 뉴스피드 확인하기',
    'Go to my profile page': '프로필 페이지로 가기',
    'Scroll Down': '스크롤 다운',
    'Change password': '암호 변경',
    'You can change your password by submitting the form below. The new password must be different than your last five passwords.': '아래 서식을 제출하면 암호가 변경됩니다. 새 암호는 과거 사용했던 암호들 중 가장 최근의 5개와는 달라야 합니다.',
    'Your password has been changed successfully.': '암호가 성공적으로 변경되었습니다.',
    'Current password': '현재 암호',
    'New password': '새 암호',
    'Repeat new password': '새 암호 재입력',
    'product_focus_new': '신규',
    'product_focus_started': '시작됨',
    'product_focus_completed': '완료됨',
    'Product focus': '제품 포커스',
    'New Product Focus': '신제품 포커스',
    'Later': '다음',
    'View Product Focus': '제품 포커스 보기',
    'Do you want to enable secure authentication for a faster and easier access?': '더 빠르고 쉬운 접근을 위해 보안 인증을 사용하시겠습니까?',
    'Secure authentication failed': '보안 인증 실패',

    'Hot now': 'Hot now',
    'To complete': 'To complete',
    'Never seen': 'Never seen',
    'seasonal': '컬렉션',
    'timeless': '타임리스',
    'glossary': '용어 사전',
    'product-focus': 'Product focus',
    'merchandising-manual': '매뉴얼',
    'never seen': 'Never seen',
    'manuals': '매뉴얼',
    'terms': '약관',
    'more': '더 보기',
    'Show all seasonal': '모든 컬렉션 보기',
    'Show all timeless': '모든 타임리스 보기',
    'Show all glossary': '모든 용어사전 보기',
    'Show all product-focus': '모든 PRODUCT FOCUS',
    'Show all merchandising-manual': '모든 매뉴얼 보기',

    'You are currently logged-in as :email, is that you?': '현재 :email 로 로그인되어 있습니다, 본인이십니까?',
    'Yes': '예',
    'No, logout': '아니요, 로그아웃',
  },
  pt_PT: {
    'EUR': 'Europe',
    'MDE': 'Middle East',
    'AMR': 'USA',
    'KOR': 'Korea',
    'FST': 'Hong Kong + Macao + Taiwan',
    'CHI': 'China Mainland',
    'JAP': 'Japan',
    'BRZ': 'Brazil',
    'SEA': 'Sea',

    'Home': 'Página Inicial',
    'Seasonal': 'Seasonal',
    'Seasonal Archive': 'Arquivo Seasonal',
    'Timeless': 'Timeless',
    'Introduction': 'Introdução',
    'Themes': 'Temas',
    'Manuals': 'Manuais',
    'Merchandising Manuals': 'Manuais de Merchandising',
    ':length themes available': ':length temas disponíveis',
    'Go to top': 'Ir para o topo',
    'All': 'Tudo',
    'Alphabetical': 'Alfabético',
    'Newest': 'Mais recente',
    'Glossary': 'Glossário',
    'Sort by': 'Ordenar por',
    'Filter by': 'Filtrar por',
    'Search': 'Pesquisa',
    'Archive': 'Arquivo',
    'Discover Also': 'Descubra também',
    'Start now': 'Começar agora',
    'Themes (:length)': 'Temas (:length)',
    'To Complete': 'Para completar',
    'Seasonal / Non seasonal': 'Seasonal / Non seasonal',
    'Updated Content': 'Conteúdo atualizado',
    'Your Valentino Username (5 digits)': 'Seu nome de usuário Valentino (5 dígitos)',
    'Username or password are incorrect': 'Nome de usuário ou senha incorretos',
    'Login failed': 'Falha no login',
    'Loading...': 'Carregando ...',
    'Congratulations!': 'Parabéns!',
    'Username': 'Username',
    'Password': 'Password',
    'Related content': 'CONTEÚDOS RELACIONADOS',
    'User area': 'Área do usuário',
    'Language': 'Idioma',
    'English': 'Inglês',
    'Japanese': 'Japonês',
    'Korean': 'Coreano',
    'Portuguese': 'Português',
    'Russian': 'Russo',
    'Chinese': 'Chinês',
    'Feedback': 'Feedback',
    'Logout': 'Logout',
    'Video Manual': 'Video Manual',
    'Store': 'Loja',
    'Stores': 'Lojas',
    'Theme completed': 'Tema concluído',
    'Completed: :percentage%': 'Concluído: :percentage%',
    'Search results': 'Resultados da pesquisa',
    'Your search results for:': 'Resultados da pesquisa para:',
    'No search results for ":query"': 'enhum resultado para ":query"',
    'Try to change your search query': 'Tente mudar sua consulta de pesquisa',
    'Try to change your filters': 'Tente mudar seus filtros ',
    'Category': 'Categoria',
    'theme_new': 'Novo',
    'theme_viewed': 'Começado',
    'theme_completed': 'Concluído',
    'theme_updated': 'Atualizado',
    'Got the big picture? Now let’s go deeper': 'FICASTE COM UMA PERSPECTIVA GERAL? AGORA VAMOS MAIS FUNDO',
    'That’s great, keep up and move to the next one!': 'ÓTIMO! VAI PARA O PRÓXIMO!',
    'That’s great!': 'ÓTIMO!',
    'Go to archive': 'Vá para o arquivo',
    'View all': 'Ver tudo',
    'There are some new content for you!': 'Tem novos contéudos para você!',
    'Check out your notification': 'Cheque suas notificações',
    'Go to notification': 'Vá para notificações',
    'Reports': 'Relatórios',
    'Worldwide :percentage': 'Mundo Todo :percentage',
    // @todo 2019-11-05
    //   "Worldwide" was copied and modified from above entry, should be
    //   validated
    'Worldwide': 'Mundo Todo',
    'Name': 'Nome',
    'Active users': 'Users Ativos',
    'Content done': 'Conteúdo Feito',
    'Completed theme': 'Tema Completado',
    'Active': 'Ativo',
    'Inactive': 'Inativo',
    'Report a problem': 'Reportar um problema',
    'Report :count person': 'Reportar :count pessoa',
    'Report :count people': 'Reportar :count pessoas',
    'Expand': 'Expandir',
    'Close': 'Fechar',
    'No results for the selected store.': 'Nenhum resultado para a loja selecionada',
    'No results for the selected country.': 'Nenhum resultado para o país selecionado',
    'No results for the selected region.': 'Nenhum resultado para a região selecionada',
    'No results for the selected collection.': 'Nenhum resultado para a coleção selecionada',
    'No results for the selected user.': 'Nenhum resultado para o user selecionado',
    'When you are done studying, mark this theme as completed by tapping the button below.': 'Quando terminar de estudar, marque esse tema como completado apertando o botão abaixo',
    'Mark as completed': 'Marque como completo',
    'Check all the collection themes': 'Cheque todos os temas da coleção',
    'Logging in...': 'Entrando....',
    'Login': 'Login',
    'Notifications': 'Notificações',
    'News feed': 'Noticias',
    'No news available': 'Nenhuma novidade disponivel',
    ':length media': ':length Midia',
    'No Glossary terms found': 'Nenhum termo encontrado',
    'Find out all the collection themes': 'Encontre todos os temas da coleção',
    'Find out all the category themes': 'Descubra todas as categorias',
    'There are news for you!': 'Tem novidades para você!',
    'Check out the news feed in your page': 'Veja as novidades em sua página',
    'Go to my profile page': 'Va para o meu perfil',
    'Scroll Down': 'Desça',
    'Change password': 'Alterar password',
    'You can change your password by submitting the form below. The new password must be different than your last five passwords.': 'Pode alterar a password da sua conta enviando o formulário abaixo. A nova password deve ser diferente das suas últimas cinco passwords.',
    'Your password has been changed successfully.': 'A sua password foi alterada com sucesso.',
    'Current password': 'Password atual',
    'New password': 'Nova password',
    'Repeat new password': 'Repetir nova password',
    'product_focus_new': 'Novo',
    'product_focus_started': 'Começado',
    'product_focus_completed': 'Concluído',
    'Product focus': 'Foco do produto',
    'New Product Focus': 'Novo Foco do produto',
    'Later': 'Mais tarde',
    'View Product Focus': 'Ver Foco do produto',
    'Do you want to enable secure authentication for a faster and easier access?': 'Quer habilitar a autenticação segura para um acesso mais rápido e fácil?',
    'Secure authentication failed': 'A autenticação segura falhou',

    'Hot now': 'Novidade',
    'To complete': 'Completar',
    'Never seen': 'Nunca visto',
    'seasonal':	'sazonal',
    'timeless': 'Intemporal',
    'glossary':	'glossário',
    'product-focus':	'foco no produto',
    'merchandising-manual':	'manuais',
    'never seen': 'Nunca visto',
    'manuals': 'manuais',
    'terms': 'termos',
    'more': 'mais',
    'Show all seasonal': 'Mostrar todos Sazonal',
    'Show all timeless': 'Mostrar todos Intemporal',
    'Show all glossary': 'Mostrar todos Glossário',
    'Show all product-focus': 'Mostrar todos Foco no produto',
    'Show all merchandising-manual': 'Mostrar todos Manuais',

    'You are currently logged-in as :email, is that you?': 'Está atualmente autenticado como :email, é você?',
    'Yes': 'Sim',
    'No, logout': 'Não, terminar sessão',
  },
  ru_RU: {
    'EUR': 'Europe',
    'MDE': 'Middle East',
    'AMR': 'USA',
    'KOR': 'Korea',
    'FST': 'Hong Kong + Macao + Taiwan',
    'CHI': 'China Mainland',
    'JAP': 'Japan',
    'BRZ': 'Brazil',
    'SEA': 'Sea',

    'Home': 'Домашняя страница',
    'Seasonal': 'Сезонные коллекции',
    'Seasonal Archive': 'Архив сезонных коллекций',
    'Timeless': 'На все времена',
    'Introduction': 'Введение',
    'Themes': 'Темы',
    'Manuals': 'Справочники',
    'Merchandising Manuals': 'Справочники по товарам',
    ':length themes available': 'Доступных тем: :length',
    'Go to top': 'Перейти вверх',
    'All': 'Все',
    'Alphabetical': 'По алфавиту',
    'Newest': 'Новые',
    'Glossary': 'Глоссарий',
    'Sort by': 'Сортировать по',
    'Filter by': 'Отфильтровать по',
    'Search': 'Поиск',
    'Archive': 'Архив',
    'Discover Also': 'Посмотреть также',
    'Start now': 'Начать сейчас',
    'Themes (:length)': 'Темы: (:length)',
    'To Complete': 'Завершить',
    'Seasonal / Non seasonal': 'Сезонные / Не сезонные',
    'Updated Content': 'Обновить содержимое',
    'Your Valentino Username (5 digits)': 'Ваше имя пользователя Valentino (5 цифр)',
    'Username or password are incorrect': 'Неправильное имя пользователя или пароль',
    'Login failed': 'Не удалось войти',
    'Loading...': 'Загружается…',
    'Congratulations!': 'Поздравляем!',
    'Username': 'Имя пользователя',
    'Password': 'Пароль',
    'Related content': 'СООТВЕТСТВУЮЩЕЕ СОДЕРЖИМОЕ',
    'User area': 'Страница пользователя',
    'Language': 'Язык',
    'English': 'Английский',
    'Japanese': 'Японский',
    'Korean': 'Корейский',
    'Portuguese': 'Португальский',
    'Russian': 'Русский',
    'Chinese': 'Китайский',
    'Feedback': 'Обратная связь',
    'Logout': 'Выйти',
    'Video Manual': 'Видео-руководство',
    'Store': 'Магазин',
    'Stores': 'Магазины',
    'Theme completed': 'Тема завершена',
    'Completed: :percentage%': 'Завершено: :percentage%',
    'Search results': 'Результаты поиска',
    'Your search results for:': 'Ваши результаты поиска:',
    'No search results for ":query"': 'е найдено результатов для ":query"',
    'Try to change your search query': 'Попробуйте изменить поисковый запрос',
    'Try to change your filters': 'Попробуйте изменить ваши фильтры',
    'Category': 'Категория',
    'theme_new': 'Новый',
    'theme_viewed': 'Начато',
    'theme_completed': 'Завершено',
    'theme_updated': 'Обновлено',
    'Got the big picture? Now let’s go deeper': 'УВИДЕЛИ ОБЩУЮ КАРТИНУ? ТЕПЕРЬ ДАВАЙТЕ РАССМОТРИМ ДЕТАЛИ',
    'That’s great, keep up and move to the next one!': 'ВЕЛИКОЛЕПНО! ТАК ДЕРЖАТЬ! ИДЁМ ДАЛЬШЕ',
    'That’s great!': 'ОТЛИЧНО!',
    'Go to archive': 'Перейти в архив',
    'View all': 'Посмотреть всё',
    'There are some new content for you!': 'Новое содержимое для Вас!',
    'Check out your notification': 'Просмотрите наше уведомление',
    'Go to notification': 'Перейти к уведомлению',
    'Reports': 'Отчёты',
    'Worldwide :percentage': 'По всему миру :percentage',
    // @todo 2019-11-05
    //   "Worldwide" was copied and modified from above entry, should be
    //   validated
    'Worldwide': 'По всему миру',
    'Name': 'Имя',
    'Active users': 'Активные пользователи',
    'Content done': 'Пройдено содержимого',
    'Completed theme': 'Завершённая группа',
    'Active': 'Активен',
    'Inactive': 'Неактивен',
    'Report a problem': 'Сообщить о проблеме',
    'Report :count person': 'Сообщить о :count человеке',
    'Report :count people': 'Сообщить о :count людях',
    'Expand': 'Расширить',
    'Close': 'Закрыть',
    'No results for the selected store.': 'Нет результатов для выбранного магазина.',
    'No results for the selected country.': 'Нет результатов для выбранной страны.',
    'No results for the selected region.': ' Нет результатов для выбранного региона.',
    'No results for the selected collection.': 'Нет результатов для выбранной коллекции.',
    'No results for the selected user.': 'Нет результатов для выбранного пользователя.',
    'When you are done studying, mark this theme as completed by tapping the button below.': 'После завершения обучения отметьте данную группу как завершённую, нажав на кнопку ниже',
    'Mark as completed': 'Отметить как завершённую',
    'Check all the collection themes': 'Просмотреть все группы коллекции',
    'Logging in...': 'Осуществляется вход в учётную запись...',
    'Login': 'Вход в учётную запись',
    'Notifications': 'Уведомления',
    'News feed': 'Лента новостей',
    'No news available': 'Нет новостей',
    ':length media': ':length медиа',
    'No Glossary terms found': 'Термины в глоссарии не найдены',
    'Find out all the collection themes': 'Узнайте больше обо всех группах коллекции',
    'Find out all the category themes': 'Просмотрите все группы категории',
    'There are news for you!': 'Новости для вас!',
    'Check out the news feed in your page': 'Посмотрите новостную ленту на вашей странице',
    'Go to my profile page': 'Перейти на мою страницу профиля',
    'Scroll Down': 'Листать вниз',
    'Change password': 'Изменить пароль ',
    'You can change your password by submitting the form below. The new password must be different than your last five passwords.': 'Вы можете изменить пароль своей учетной записи, отправив форму ниже. Новый пароль должен отличаться от ваших последних пяти паролей.',
    'Your password has been changed successfully.': 'Ваш пароль был успешно изменен.',
    'Current password': 'Текущий пароль ',
    'New password': 'Новый пароль',
    'Repeat new password': 'Повторите новый пароль',
    'product_focus_new': 'Новый',
    'product_focus_started': 'Начато',
    'product_focus_completed': 'Завершено',
    'Product focus': 'Фокус на продукт',
    'New Product Focus': 'Фокус на новый продукт',
    'Later': 'Позже',
    'View Product Focus': 'Посмотреть фокус на продукт',
    'Do you want to enable secure authentication for a faster and easier access?': 'Вы хотите включить безопасную аутентификацию для более быстрого и простого доступа?',
    'Secure authentication failed': 'Безопасная аутентификация не удалась',

    'Hot now': 'Популярно сейчас',
    'To complete': 'Для завершения',
    'Never seen': 'Не представленное ранее',
    'seasonal':	'сезонное',
    'timeless': 'всегда актуальное',
    'glossary':	'глоссарий',
    'product-focus':	'акцент на товарах',
    'merchandising-manual':	'руководства',
    'never seen': 'не представленное ранее',
    'manuals': 'руководства',
    'terms': 'условия',
    'more': 'больше',
    'Show all seasonal': 'Показать все Сезонное',
    'Show all timeless': 'Показать все Всегда актуальное',
    'Show all glossary': 'Показать все Глоссарий',
    'Show all product-focus': 'Показать все Акцент на товарах',
    'Show all merchandising-manual': 'Показать все Руководства',

    'You are currently logged-in as :email, is that you?': 'Вы в настоящий момент вошли как :email, это вы?',
    'Yes': 'Да',
    'No, logout': 'Нет, выйти',
  },
  ar_AE: {
    'EUR': 'Europe',
    'MDE': 'Middle East',
    'AMR': 'USA',
    'KOR': 'Korea',
    'FST': 'Hong Kong + Macao + Taiwan',
    'CHI': 'China Mainland',
    'JAP': 'Japan',
    'BRZ': 'Brazil',
    'SEA': 'Sea',

    'Home': 'الرئيسية',
    'Seasonal': 'موسمي',
    'Seasonal Archive': 'ارشيف موسمي',
    'Timeless': 'مناسب لجميع الأزمنة',
    'Introduction': 'مقدمة',
    'Themes': 'المواضيع',
    'Manuals': 'كتيبات',
    'Merchandising Manuals': 'كتيبات التسويق السلعي',
    ':length themes available': ':length إتاحة المواضيع',
    'Go to top': 'إلى الأعلى',
    'All': 'الجميع',
    'Alphabetical': 'الترتيب حسب الحروف الهجائية',
    'Newest': 'الأحدث',
    'Glossary': 'مسرد المصطلحات',
    'Sort by': 'التصنيف حسب',
    'Filter by': 'الفرز حسب',
    'Search': 'بحث',
    'Archive': 'أرشيف',
    'Discover Also': 'تعرّف أيضاً على',
    'Start now': 'ابدأ هنا',
    'Themes (:length)': 'المواضيع (:length)',
    'To Complete': 'للإكمال',
    'Seasonal / Non seasonal': 'موسمي / غير موسمي',
    'Updated Content': 'محتوى تم تحديثه',
    'Your Valentino Username (5 digits)': ' اسم المستخدم الخاص بك لدى فالنتينو (5 أرقام)',
    'Username or password are incorrect': 'اسم المستخدم أو كلمة المرور غير صحيحة',
    'Login failed': 'فشل تسجيل الدخول',
    'Loading...': 'جاري التحميل ...',
    'Congratulations!': 'تهانينا!',
    'Username': 'اسم المستخدم',
    'Password': 'كلمة المرور',
    'Related content': 'محتويات ذات علاقة',
    'User area': 'منطقة المستخدم',
    'Language': 'اللغة',
    'English': 'الانجليزية',
    'Japanese': 'اليابانية',
    'Korean': 'الكورية',
    'Portuguese': 'البرتغالية',
    'Russian': 'الروسية',
    'Chinese': 'الصينية',
    'Feedback': 'آراء واردة',
    'Logout': 'تسجيل الخروج',
    'Video Manual': 'دليل الفيديو',
    'Store': 'متجر',
    'Stores': 'متاجر',
    'Theme completed': 'اكتمال الموضوع',
    'Completed: :percentage%': 'اكتمل: %:percentage', // @todo 2019-10-16 updated
    'Search results': 'نتائج البحث',
    'Your search results for:': 'نتائج بحثك عن:',
    'No search results for ":query"': 'لا توجد نتائج عن "query:"',
    'Try to change your search query': 'حاول تغيير استعلام البحث الخاص بك',
    'Try to change your filters': 'حاول تغيير عوامل التصفية الخاصة بك',
    'Category': 'الفئة',
    'theme_new': 'جديد',
    'theme_viewed': 'بدأ',
    'theme_completed': 'اكتمل',
    'theme_updated': 'تم تحديثه',
    'Got the big picture? Now let’s go deeper': 'هل وصلتك الفكرة العامة؟ لنذهب إلى صُلب الموضوع الآن',
    'That’s great, keep up and move to the next one!': 'رائع، استمر وانتقل إلى التالي!',
    'That’s great!': 'هذا رائع!',
    'Go to archive': 'انتقل إلى الارشيف',
    'View all': 'عرض الجميع',
    'There are some new content for you!': 'هناك أخبار لك!',
    'Check out your notification': 'تحقق من إشعارك',
    'Go to notification': 'الذهاب إلى الإخطار',
    'Reports': 'تقارير',
    'Worldwide :percentage': 'على المستوى %:percentage', // @todo 2019-10-16 updated
    // @todo 2019-11-05
    //   "Worldwide" was copied and modified from above entry, should be
    //   validated
    'Worldwide': 'على المستوى',
    'Name': 'الاسم',
    'Active users': 'مستخدمون نشطون',
    'Content done': 'محتوى تم إنجازه',
    'Completed theme': 'موضوع تم إتمامه',
    'Active': 'نشط',
    'Inactive': 'غير نشط',
    'Report a problem': 'الإبلاغ عن مشكلة',
    'Report :count person': 'الإبلاغ عن :count شخص',
    'Report :count people': 'الإبلاغ عن :count أشخاص',
    'Expand': 'توسيع',
    'Close': 'إغلاق',
    'No results for the selected store.': 'لا توجد نتائج عن المتجر الذي تم اختياره.',
    'No results for the selected country.': 'لا توجد نتائج عن البلد الذي تم اختياره.',
    'No results for the selected region.': 'لا توجد نتائج عن المنطقة التي تم اختيارها.',
    'No results for the selected collection.': 'لا توجد نتائج عن التشكيلة التي تم اختيارها.',
    'No results for the selected user.': 'لا توجد نتائج عن المستخدم الذي تم اختياره.',
    'When you are done studying, mark this theme as completed by tapping the button below.': 'عند الانتهاء من الدراسة، حدد هذا الموضوع بإشارة للدلالة على أنه مكتمل وذلك بالنقر على الزر أدناه',
    'Mark as completed': 'ضع إشارة اكتمال',
    'Check all the collection themes': 'تحقق من جميع مواضيع التشكيلة',
    'Logging in...': 'جاري تسجيل الدخول...',
    'Login': 'تسجيل الدخول',
    'Notifications': 'إشعارات',
    'News feed': 'أحدث الأخبار',
    'No news available': 'لا توجد أخبار متاحة',
    ':length media': ':length الإعلام', // @todo 2019-10-16 updated
    'No Glossary terms found': 'لم يتم العثور على مصطلحات مسرد',
    'Find out all the collection themes': 'تعرّف عل جميع مواضيع التشكيلة',
    'Find out all the category themes': 'تعرّف على جميع مواضيع الفئة',
    'There are news for you!': 'هناك أخبار لك!',
    'Check out the news feed in your page': 'تعرّف على أحدث الأخبار على صفحتك',
    'Go to my profile page': 'انتقل إلى الصفحة الشخصية ',
    'Scroll Down': 'انزل بالصفحة إلى الأسفل', // @todo 2019-10-16 2019-10-16 too much text, too long
    'Change password': 'تغيير كلمة المرور',
    'You can change your password by submitting the form below. The new password must be different than your last five passwords.': 'يمكنك تغيير كلمة المرور عن إرسال النموذج أدناه. يجب أن تكون كلمة المرور مختلفة عن آخر خمس كلمات مرور خاصة بك',
    'Your password has been changed successfully.': 'تم تغيير كلمة المرور بنجاح',
    'Current password': 'كلمة المرور الحالية',
    'New password': 'كلمة المرور الجديدة',
    'Repeat new password': 'إعادة كلمة المرور',
    'product_focus_new': 'جديد',
    'product_focus_started': 'بدأ',
    'product_focus_completed': 'اكتمل',
    'Product focus': 'دليل الفيديو',
    'New Product Focus': 'محط تركيز المنتج',
    'Later': 'محط تركيز المنتج الجديد',
    'View Product Focus': 'فيما بعد',
    'Do you want to enable secure authentication for a faster and easier access?': 'هل ترغب في تفعيل تصديق آمن لتسريع وتيسير الوصول؟',
    'Secure authentication failed': 'فشل التصديق الآمن',

    'Hot now': 'الأكثر شيوعاً الآن',
    'To complete': 'يجب أن يستكمل',
    'Never seen': 'لم يُرى من قبل',
    'seasonal':	'قطع موسمية',
    'timeless': 'قطع خالدة',
    'glossary':	'فهرس',
    'product-focus':	'التركيزعلى المنتج',
    'merchandising-manual':	'كتيبات',
    'never seen': 'لم يُرى من قبل',
    'manuals': 'كتيبات',
    'terms': 'شروط',
    'more': 'المزيد',
    'Show all seasonal': 'عرض كل ما هو متعلق بالقطع الموسمية',
    'Show all timeless': 'عرض كل ما هو متعلق بالقطع الخالدة',
    'Show all glossary': 'عرض الفهرس بأكمله',
    'Show all product-focus': 'عرض كل ما هو متعلق بالتركيز على المنتج ',
    'Show all merchandising-manual': 'عرض جميع الكتيبات',

    'You are currently logged-in as :email, is that you?': 'أنت الآن مسجل الدخول كـ :email، هل هذا أنت؟',
    'Yes': 'نعم',
    'No, logout': 'لا، تسجيل الخروج',
  },
  th_TH: {
    'EUR': 'Europe',
    'MDE': 'Middle East',
    'AMR': 'USA',
    'KOR': 'Korea',
    'FST': 'Hong Kong + Macao + Taiwan',
    'CHI': 'China Mainland',
    'JAP': 'Japan',
    'BRZ': 'Brazil',
    'SEA': 'Sea',

    'Scroll Down': 'เลื่อนลง', // @todo 2022-02-07 from Google Translate

    'Home': 'หน้าหลัก',
    'Seasonal': 'คอลเลคชันประจำฤดู',
    'Seasonal Archive': 'ข้อมูลสำคัญประจำฤดู',
    'Timeless': 'งานออกแบบที่ใช้ได้ในทุกยุคสมัย',
    'Introduction': 'ข้อมูลเบื้องต้น',
    'Themes (:length)': 'แนวคิดต่างๆ ทางการออกแบบ (:length)',
    'Manuals': 'คู่มือ',
    'Merchandising Manuals': 'คู่มือการจัดแสดงสินค้าภายในบูติก',
    ':length themes available': ':lengthการออกแบบที่มีจำหน่าย',
    'Go to top': 'ย้อนกลับไปหน้าแรก',
    'All': 'ดูคำศัพท์ทั้งหมด',
    'Alphabetical': 'ดูคำศัพท์เรียงตามลำดับตัวอักษร',
    'Newest': 'ใหม่ล่าสุด',
    'Glossary': 'อภิธานศัพท์',
    'Sort by': 'เลือกตามการเรียงลำดับ',
    'Filter by': 'เลือกตามการแบ่งประเภท',
    'Search': 'ค้นหา',
    'Archive': 'หน่วยเก็บข้อมูลสำคัญ',
    'Discover Also': 'ค้นหาพร้อมกัน',
    'Start now': 'เริ่มต้นตอนนี้',
    'To Complete': 'เพื่อความครบถ้วน',
    'Seasonal / Non seasonal': 'สินค้าประจำฤดู/ไม่ประจำฤดู',
    'Updated Content': 'เนื้อหาปรับปรุงใหม่ล่าสุด',
    'Your Valentino Username (5 digits)': 'ชื่อผู้ใช้บัญชี Valentino ของคุณ (5 ตัวอักษร)',
    'Username or password are incorrect': 'ชื่อผู้ใช้ หรือรหัสผ่านไม่ถูกต้อง',
    'Login failed': 'การโหลดข้อมูลล้มเหลว',
    'Loading...': 'กำลังโหลดข้อมูล...',
    'Congratulations!': 'ขอแสดงความยินดี!',
    'Username': 'ชื่อผู้ใช้',
    'Password': 'รหัสผ่าน',
    'Got the big picture? Now let’s go deeper': 'เมื่อเข้าใจในภาพรวม เราจะเข้าสู่ข้อมูลเบื้องลึก!',
    'That’s great, keep up and move to the next one!': 'ยอดเยี่ยม, จดจำ และเข้าสู่บทต่อไป!',
    'Related content': 'เนื้อหาที่เกี่ยวข้อง',
    'User area': 'เขตพื้นที่ของผู้ใช้งาน',
    'Language': 'ภาษา',
    'English': 'อังกฤษ',
    'Japanese': 'ญี่ปุ่น',
    'Korean': 'เกาหลี',
    'Portuguese': 'โปรตุเกส',
    'Russian': 'รัสเซีย',
    'Chinese': 'จีน',
    'Feedback': 'ผลตอบรับ',
    'Logout': 'ออกจากระบบ',
    'Store': 'บูติกร้านค้าเดี่ยว',
    'Stores': 'บูติกร้านค้าสาขาต่างๆ',
    'Theme completed': 'เรียนรู้ข้อมูลแนวทางการออกแบบครบถ้วน',
    'Completed: :percentage%': 'ครบถ้วน: :percentage%',
    'Search results': 'ผลการค้นหา',
    'Your search results for:': 'ผลการค้นหาของคุณ:',
    'No search results for ":query"': 'ไม่มีผลการค้นหาสำหรับ ":query"',
    'Try to change your search query': 'ลองเปลี่ยนข้อความที่ใช้ในการค้นหา',
    'Try to change your filters': 'ลองเปลี่ยนประเภทข้อมูลสำหรับการค้นหา',
    'Category': 'ประเภท',
    'theme_new': 'ใหม่',
    'theme_viewed': 'เริ่มต้น',
    'theme_completed': 'เสร็จสมบูรณ์',
    'theme_updated': 'ปรับปรุงใหม่ล่าสุด',
    'product_focus_new': 'ใหม่',
    'product_focus_started': 'เริ่มต้น',
    'product_focus_completed': 'เสร็จสมบูรณ์',
    'That’s great!': 'ยอดเยี่ยมมาก!',
    'Go to archive': 'ไปยังหน่วยเก็บข้อมูลสำคัญ',
    'View all': 'เรียกดูทั้งหมด',
    'Reports': 'รายงาน',
    'Worldwide :percentage': 'ทั่วโลก :percentage%',
    'Name': 'ชื่อ',
    'Active users': 'จำนวนผู้ใช้งานปัจจุบัน',
    'Content done': 'เรียนรู้เนื้อหาครบถ้วน',
    'Completed theme': 'เรียนรู้ข้อมูลแนวทางการออกแบบครบถ้วน',
    'Active': 'ใช้งานได้',
    'Inactive': 'ใช้งานไม่ได้',
    'Report a problem': 'รายงานปัญหา',
    'Report :count person': 'รายงาน :count บุคคล',
    'Report :count people': 'รายงาน :count คน',
    'Expand': 'เพิ่ม',
    'Close': 'ปิด',
    'No results for the selected store.': 'ไม่มีร้านค้าที่เลือก',
    'No results for the selected country.': 'ไม่มีประเทศที่เลือก',
    'No results for the selected region.': 'ไม่ปรากฏภูมิภาคที่เลือก',
    'No results for the selected collection.': 'ไม่ปรากฏคอลเลคชันที่เลือก',
    'No results for the selected user.': 'ไม่ปรากฏผู้ใช้งานที่ถูกเลือก',
    'When you are done studying, mark this theme as completed by tapping the button below.': 'เมื่อคุณเรียนรู้จบแล้ว กดปุ่มข้างล่างเพื่อแสดงเครื่องหมายจบบท',
    'Mark as completed': 'แสดงเครื่องหมายระบุจบสิ้นการเรียนรู้ในบทนี้',
    'Check all the collection themes': 'ตรวจดูแนวทางการออกแบบคอลเลคชันทั้งหมด',
    'Logging in...': 'เชื่อมต่อเข้าสู่ระบบ...',
    'Login': 'เข้าสู่ระบบ',
    'Notifications': 'การแจ้งเตือน',
    'News feed': 'แสดงข่าวสารใหม่',
    'No news available': 'ไม่มีข่าวสารใหม่ปรากฏ',
    ':length media': ':length สื่อ',
    'Completed: %': 'ครบถ้วน: %',
    'No Glossary terms found': 'ไม่พบคำอธิบายศัพท์',
    'Find out all the collection themes': 'ค้นหาแนวทางการออกแบบคอลเลคชันทั้งหมด',
    'Find out all the category themes': 'ค้นหาแนวทางการออกแบบประเภทต่างๆ ทั้งหมด',
    'There are some new content for you!': 'มีข่าวสารสำหรับคุณ!',
    'Check out the news feed in your page': 'ตรวจดูข่าวสารใหม่ในหน้าเพจของคุณ',
    'Go to my profile page': 'ไปยังหน้าเพจข้อมูลส่วนตัวของฉัน',
    'Check out your notification': 'ตรวจดูการแจ้งเตือนของคุณ',
    'Go to notification': 'ไปยังการแจ้งเตือน',
    'You can change your password by submitting the form below. The new password must be different than your last five passwords.': 'คุณสามารถเปลี่ยนรหัสผ่านเข้าใช้งานได้ด้วยการกรอกข้อมูล และส่งแบบฟอร์มด้านล่าง รหัสผ่านใหม่จะต้องแตกต่างจากรหัสผ่านที่ใช้ห้าครั้งสุดท้ายของคุณ',
    'Your password has been changed successfully.': 'รหัสผ่านของคุณได้รับการเปลี่ยนแปลงเรียบร้อยแล้ว',
    'Current password': 'รหัสผ่านปัจจุบัน',
    'New password': 'รหัสผ่านใหม่',
    'Repeat new password': 'ป้อนรหัสผ่านใหม่ซ้ำอีกครั้ง',
    'Change password': 'เปลี่ยนรหัสผ่าน',
    'Video Manual': 'คู่มือในรูปแบบวิดิโอ',
    'Product focus': 'ผลิตภัณฑ์สำคัญ',
    'New Product Focus': 'ผลิตภัณฑ์สำคัญรุ่นใหม่',
    'Later': 'ต่อมา',
    'View Product Focus': 'เรียกดูผลิตภัณฑ์สำคัญ',
    'Do you want to enable secure authentication for a faster and easier access?': 'คุณต้องการให้มีการตรวจสอบเพื่อยืนยันความถูกต้องของผู้ใช้งานระบบหรือไม่?',
    'Secure authentication failed': 'การตรวจสอบเพื่อยืนยันความถูกต้องล้มเหลว',

    'Hot now': 'สดๆร้อนๆ',
    'To complete': 'ต้องทำให้เสร็จ',
    'Never seen': 'ไม่เคยเห็นมาก่อน',
    'seasonal':	'ตามฤดูกาล',
    'timeless': 'ตลอดกาล',
    'glossary':	'อภิธานศัพท์',
    'product-focus': 'เน้นผลิตภัณฑ์',
    'merchandising-manual':	'คู่มือ',
    'never seen': 'ไม่เคยเห็นมาก่อน',
    'manuals': 'คู่มือ',
    'terms': 'ข้อกำหนด',
    'more': 'เพิ่มเติม',
    'Show all seasonal': 'แสดงทั้งหมด ตามฤดูกาล',
    'Show all timeless': 'แสดงทั้งหมด ตลอดกาล',
    'Show all glossary': 'แสดงทั้งหมด อภิธานศัพท์',
    'Show all product-focus': 'แสดงทั้งหมด เน้นผลิตภัณฑ์',
    'Show all merchandising-manual': 'แสดงทั้งหมด คู่มือ',

    'You are currently logged-in as :email, is that you?': 'คุณกำลังเข้าสู่ระบบในชื่อ :email ใช่คุณหรือไม่?',
    'Yes': 'ใช่',
    'No, logout': 'ไม่, ออกจากระบบ',
  },
};

function translate(key, language) {
  return languages[language] && languages[language][key]
    ? languages[language][key]
    : key; // @todo 2019-05-23 Consider using UK as default instead of the key translate(key, 'en_UK')
}

export default function __(text, attributes = {}) {
  return translate(text, UserStore.getLanguageCode()).replace(/:(\w+)/g, (match, attribute) => {
    return attributes[attribute];
  });
};
